import React, { FunctionComponent, useEffect, useState } from 'react';
import Slider from 'react-slick';
import type { Props } from './types';

const BREAKPOINT = 781;

const mobileSettings = {
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: false,
  infinite: true,
  centerMode: true,
  centerPadding: '10%',
  dots: true,
  draggable: true,
  swipe: true,
};

export const Presentation: FunctionComponent<Props> = ({ recruitments, noimage }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < BREAKPOINT);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const items = recruitments.map((r, i) => (
    <div
      key={r.id}
      className="sitetop-recruitment-container-link gtm-recruitment-view-count"
      data-event-name="recruitments on screen"
      data-category="topcontent"
      data-value={i < 6 ? `hot_recruitment${i + 1}` : 'hot_recruitment'}
      data-recruitmentid={r.id}
      data-companyid={r.companyId}
    >
      <div className="sitetop-recruitment-container-box">
        <div className="sitetop-recruitment-container-box-inner">
          <a
            href={`/recruitments/${r.id}`}
            data-event="click"
            data-category="topcontent"
            data-value={i < 6 ? `hot_recruitment${i + 1}` : 'hot_recruitment'}
            data-click-point="image"
            data-recruitmentid={r.id}
            data-companyid={r.companyId}
          >
            {r.image ? (
              <div
                style={{
                  background: `url(${r.image}) no-repeat center center`,
                  backgroundSize: 'cover',
                }}
                className="sitetop-recruitment-container-box-inner-img-bg"
              />
            ) : (
              <img
                src={noimage}
                alt={`${r.title}のカバー写真`}
                className="sitetop-recruitment-container-box-img"
              />
            )}
          </a>
          <div className="sitetop-recruitment-container-box-inner-bottom">
            <a
              href={`/recruitments/${r.id}`}
              data-event="click"
              data-category="topcontent"
              data-value={i < 6 ? `hot_recruitment${i + 1}` : 'hot_recruitment'}
              data-click-point="title"
              data-recruitmentid={r.id}
              data-companyid={r.companyId}
            >
              <div className="sitetop-recruitment-container-box-title">
                {r.title}
              </div>
              <div className="sitetop-recruitment-container-box-occupation">
                {r.occupationName && (
                  <span className="sitetop-recruitment-container-box-occupation-word">
                    {r.occupationName}
                  </span>
                )}
              </div>
            </a>
            <div className="sitetop-recruitment-container-box-company">
              <a
                href={`/companies/${r.companyId}`}
                data-event="click"
                data-category="topcontent"
                data-value={i < 6 ? `hot_recruitment${i + 1}` : 'hot_recruitment'}
                data-click-point="company"
                data-recruitmentid={r.id}
                data-companyid={r.companyId}
              >
                <span className="sitetop-recruitment-container-box-company-icon">
                  <img
                    src={r.companyIcon}
                    alt={r.companyIcon.includes('default') ? 'アイコン画像' : `${r.companyName}のロゴ写真`}
                    className="sitetop-recruitment-container-box-company-icon-img"
                  />
                </span>
              </a>
              <a
                href={`/companies/${r.companyId}`}
                className="sitetop-recruitment-container-box-company-name"
                data-event="click"
                data-category="topcontent"
                data-value={i < 6 ? `hot_recruitment${i + 1}` : 'hot_recruitment'}
                data-click-point="company"
                data-recruitmentid={r.id}
                data-companyid={r.companyId}
              >
                {r.companyName}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  ));

  return (
    <section className="sitetop-recruitment" id="hot_recruitments">
      <div className="sitetop-pickup-nav">
        <h2 className="sitetop-pickup-title">
          HOT RECRUITMENT
          <span className="sitetop-pickup-sub">募集中のオススメ求人</span>
        </h2>
        <a
          href="/search"
          className="sitetop-pickup-companies gtm-button-view-count"
          data-event-name="button on screen"
          data-event="click"
          data-category="topcontent"
          data-value="hot_recruitment_to_all"
        >
          求人一覧へ
        </a>
      </div>
      <div className="sitetop-recruitment-container">
        {isMobile ? (
          <Slider {...mobileSettings} className="sitetop-recruitment-container-inner">
            {items}
          </Slider>
        ) : (
          items
        )}
      </div>
      <a
        href="/search"
        className="sitetop-pickup-spcompanies gtm-button-view-count"
        data-event="click"
        data-category="topcontent"
        data-value="hot_recruitment_to_all"
      >
        求人一覧へ
      </a>
    </section>
  );
};
